/**
 * Singularity treats 'role' as the app we're running, but rails understands
 * it as the user role (participant or presenter). This converts it to rails.
 *
 * @param {string} appRole For example 'presenter' or 'agave'
 */
export default function appRoleToUserRole (appRole) {
  switch (appRole) {
    case 'auth':
    case 'embed':
    case 'participant':
      return 'participant'
    default:
      return 'presenter'
  }
}
